export default class FormatHelper {
    public static capitalize(value: string): string {
        if (!value) {
            return '';
        }
        return value.toUpperCase();
    }

    public static prettyTime_Hm(hh_mm_ss: string): string {
        if (!hh_mm_ss) {
            return '';
        }

        // parse all and remove leading zeros
        const parts = hh_mm_ss.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);

        if (hours > 0 && minutes > 0) {
            return `${hours} h ${minutes} min`;
        } else if (hours > 0) {
            return `${hours} h`;
        }

        return `${minutes} min`;
    }

    public static prettyTime_m(hh_mm_ss: string): string {
        if (!hh_mm_ss) {
            return '';
        }

        const parts = hh_mm_ss.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10) + hours * 60;

        return `${minutes} min`;
    }

    public static prettyLength_km(kmValue: any): string {
        if (kmValue) {
            const kmNumber = kmValue as number;
            if (kmNumber) {
                return `${Math.round(kmNumber * 10) / 10} km`;
            }
        }

        return '';
    }

    public static prettyLength_m(mValue: any): string {
        if (mValue) {
            const mNumber = mValue as number;
            if (mNumber) {
                return `${Math.round(mNumber / 10) * 10} m`;
            }
        }

        return '';
    }

    public static length_m(mValue: any): string {
        if (mValue) {
            return `${mValue} m`;
        }

        return '';
    }
}
